// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { maybeBoolean, maybeString } from "@altostra/type-validations/lib/primitives";

export const isGetMessageArchivingSettingsResponse = objectOf({
  error: maybeString,
  invalid_cloud_storage_creds: maybeBoolean,
  save_rendered_copy_of_email: maybeBoolean,
  save_rendered_copy_of_push: maybeBoolean,
  save_rendered_copy_of_sms: maybeBoolean,
});

export const isPostMessageArchivingSettingsResponse = objectOf({
  error: maybeString,
  invalid_cloud_storage_creds: maybeBoolean,
  save_rendered_copy_of_email: maybeBoolean,
  save_rendered_copy_of_push: maybeBoolean,
  save_rendered_copy_of_sms: maybeBoolean,
});
